import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SEO, SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "@/lib/seo-data";

const RouteSeo = () => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "") || "/";
  const entry = SEO[path] ?? SEO["/"];
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;

  const tripJsonLd = entry.trip
    ? {
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        name: entry.trip.name,
        description: entry.trip.description,
        url,
        ...(entry.trip.duration ? { duration: entry.trip.duration } : {}),
        provider: {
          "@type": "TravelAgency",
          name: SITE_NAME,
          url: SITE_URL,
        },
        ...(entry.trip.priceFrom
          ? {
              offers: {
                "@type": "Offer",
                price: entry.trip.priceFrom,
                priceCurrency: entry.trip.currency ?? "USD",
                availability: "https://schema.org/InStock",
                url,
              },
            }
          : {}),
      }
    : null;

  return (
    <Helmet>
      <title>{entry.title}</title>
      <meta name="description" content={entry.description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={entry.type ?? "website"} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={entry.title} />
      <meta property="og:description" content={entry.description} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={entry.title} />
      <meta name="twitter:description" content={entry.description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />

      {tripJsonLd && (
        <script type="application/ld+json">{JSON.stringify(tripJsonLd)}</script>
      )}
    </Helmet>
  );
};

export default RouteSeo;
